import { PAY_LATER_URL } from 'constants/index';
import { fetchJson } from 'utils/fetchJson/fetchJson';

const payLater = {
  sendInstructions: async (idPayment, token, email, locale) => {
    const payload = {
      method: 'POST',
      body: JSON.stringify({
        payment_id: idPayment,
        token,
        user_email: email,
        locale,
      }),
    };

    return await fetchJson(PAY_LATER_URL, payload);
  },
};

export { payLater };
